import React from 'react';
import { get, isEqual } from 'lodash';

// local dependencies
import { authFlowMemberVerificationFamilyUnit as AuthFlowMemberVerificationFamilyUnitView } from 'ui/views/widgets/authFlowMemberVerificationFamilyUnit';
import { AuthFlowMemberVerificationFamilyUnitService } from 'services/authFlowMemberVerificationFamilyUnit';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AuthFlowMemberVerificationFamilyUnitWidget } from 'ui/containers/AuthFlowMemberVerificationFamilyUnitWidget';
 *
 * // render
 * <AuthFlowMemberVerificationFamilyUnitWidget propName='propValue'/>
 */
export class AuthFlowMemberVerificationFamilyUnitWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.authFlowMemberVerificationFamilyUnitService = new AuthFlowMemberVerificationFamilyUnitService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'AuthFlowMemberVerificationFamilyUnitWidget.fetchComponentData()' );

        // cancel ongoing request
        this.authFlowMemberVerificationFamilyUnitService.cancel();

        // get status and service data
        const { status, data } = await this.authFlowMemberVerificationFamilyUnitService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                context: {
                    memberId: this.props.memberId,
                    patientId: this.props.patientId,
                }
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {
        log.debug( 'AuthFlowMemberVerificationFamilyUnitWidget.UNSAFE_componentWillReceiveProps()' );

        if( ! isEqual( nextProps.memberId, this.props.memberId ) ) {
            
            this.setState( { isFetching: true }, () => {
                this.fetchComponentData();
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.authFlowMemberVerificationFamilyUnitService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AuthFlowMemberVerificationFamilyUnitView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
            />
        );
    }
}

// set display name
AuthFlowMemberVerificationFamilyUnitWidget.displayName = 'AuthFlowMemberVerificationFamilyUnitWidget';

// set default props
AuthFlowMemberVerificationFamilyUnitWidget.defaultProps = {};

// prop types
AuthFlowMemberVerificationFamilyUnitWidget.propTypes = {};
